define('app-PopUpTP/main',[], function () {
    return {
        run: function () { }
    }
});

function showPopUp() {
    console.log('calling showPopUp');
    $("#loadingContainer").css('left', '0');
    $(".loading").css('left', '0');
    $("#myimg").attr("src", "/Content/loading.gif");
}

function hidePopUp() {
    console.log('calling hidePopUp');
    $("#loadingContainer").css('left', '5000px');
    $(".loading").css('left', '5000px');
}

function showModal() {
    console.log('calling showModal');
    $("#loadingContainer").css('left', '0');
}

function hideModal() {
    console.log('calling hideModal');
    $("#loadingContainer").css('left', '5000px');
};
